import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-records',
    templateUrl: './records.component.html'
})
export class RecordsComponent implements OnInit {

    constructor(
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs.start({name: 'Felvételek'});
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/records.component.ts